/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatLoadMessageService } from '../services/chat-load-message.service';

@Component({
  selector: 'app-chat-loader',
  templateUrl: './chat-loader.component.html',
  styleUrls: ['./chat-loader.component.scss'],
})
export class ChatLoaderComponent implements OnInit, OnDestroy {
  text: string = '';
  currentStep: number = 0;
  isShortLoading: boolean = true;
  chatLoadMessage: string = '';

  step1 = ['Analyzing your query', 'Sorting results by relevance', 'Searching'];
  step2 = [
    'Gathering data',
    'Synthesizing insights',
    'Working through the details',
  ];
  step3 = [
    'Finalizing the answer',
    'Preparing a detailed answer',
    'Wrapping things up',
  ];

  steps = [this.step1, this.step2, this.step3];

  private timeoutRef: any;
  private intervalRef: any;
  private chatLoadMessageSubscription: Subscription = new Subscription();

  constructor(private chatLoadMessageService: ChatLoadMessageService) {}

  ngOnInit(): void {
    this.chatLoadMessageSubscription =
      this.chatLoadMessageService.chatLoadingMessage$.subscribe(
        (message: string) => {
          this.chatLoadMessage = message;
          this.updateText();
          this.updateLoadingState();
        },
      );

    this.updateText();
    this.startFallbackTimer();
  }

  ngOnDestroy(): void {
    this.chatLoadMessageSubscription.unsubscribe();

    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
    if (this.intervalRef) {
      clearInterval(this.intervalRef);
    }
  }

  private updateLoadingState(): void {
    if (this.chatLoadMessage && this.chatLoadMessage.trim().length > 0) {
      this.isShortLoading = false;
      this.clearFallbackTimer();
    }
  }

  private startFallbackTimer(): void {
    this.timeoutRef = setTimeout(() => {
      this.isShortLoading = false;
      this.startGenericMessages();
    }, 5000);
  }

  private clearFallbackTimer(): void {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
      this.timeoutRef = null;
    }
  }

  private startGenericMessages(): void {
    if (!this.chatLoadMessage || this.chatLoadMessage.trim().length === 0) {
      this.cycleThroughSteps();
      this.intervalRef = setInterval(() => this.cycleThroughSteps(), 4000);
    }
  }

  private cycleThroughSteps(): void {
    const currentArray = this.steps[this.currentStep];
    const randomString =
      currentArray[Math.floor(Math.random() * currentArray.length)];
    this.text = randomString;
    this.currentStep = (this.currentStep + 1) % this.steps.length;
  }

  private updateText(): void {
    if (this.chatLoadMessage && this.chatLoadMessage.trim().length > 0) {
      this.text = this.chatLoadMessage;
    }
  }
}
